import {Injectable} from "@angular/core";
import {TranslateDefaultParser, TranslateParser, TranslateService} from '@ngx-translate/core';
import {isDefined} from "./util";
import {isObject} from 'lodash';
import * as moment from 'moment';

//@Injectable()
//export class WikTranslateParser extends TranslateDefaultParser {
//
//    templateMatcher: RegExp = /%\s?([^{}\s]*)\s?%/g;
//
//    interpolateString(expr: string, params?: any) {
//        if (!params) {
//            return expr;
//        }
//
//        return expr.replace(this.templateMatcher, (substring: string, b: string) => {
//            let r = this.getValue(params, b);
//            return isDefined(r) ? r : substring;
//        });
//    }
//
//}
@Injectable()
export class WikTranslateParser extends TranslateParser {
    //    templateMatcher: RegExp = /%\s?([^{}\s]*)%/g;
    templateMatcher: RegExp = /%\s?([val[0-9]*)%/g;

    public interpolate(expr: string | Function, params?: any): string {
        let result: string;

        if (typeof expr === 'string') {
            result = this.interpolateString(expr, params);
        } else if (typeof expr === 'function') {
            result = this.interpolateFunction(expr, params);
        } else {
            // this should not happen, but an unrelated TranslateService test depends on it
            result = expr as string;
        }
        return result;
    }

    getValue(target: any, key: string): any {
        let keys = key.split('.');
        key = '';
        do {
            key += keys.shift();
            if (isDefined(target) && isDefined(target[key]) && (typeof target[key] === 'object' || !keys.length)) {
                target = target[key];
                key = '';
            } else if (!keys.length) {
                target = undefined;
            } else {
                key += '.';
            }
        } while (keys.length);
        return target;
    }

    private interpolateFunction(fn: Function, params?: any) {
        return fn(params);
    }

    private interpolateString(expr: string, params?: any) {
        if (!params) {
            return expr;
        }
        return expr.replace(this.templateMatcher, (substring: string, b: string) => {
            let r = this.getValue(params, b);
            if (isObject(r)) {
                let date = r.format('YYYY-MM-DD HH:mm:ss');
                return moment(date).format('LLLL');
            }
            return isDefined(r) ? r : substring;
        });
    }


}